import React from "react";

interface SearchInputProps {
    id?: string;
    value?: string;
    name?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSearch?: (value: string) => void;
    placeholder?: string;
    className?: string;
    style?: React.CSSProperties;
    disabled?: boolean;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}
// A search input field component with an optional search handler triggered on "Enter".

const SearchInput: React.FC<SearchInputProps> = ({
    id,
    value,
    name,
    onChange,
    onSearch,
    onKeyDown,
    placeholder = "Search",
    className = "",
    style,
    disabled = false,
}) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && onSearch) {
            onSearch(value || "");
        }
        if (onKeyDown) {
            onKeyDown(e);
        }
    };

    return (
        <input
            id={id}
            type="search"
            value={value}
            name={name}
            onChange={onChange}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            className={`form-control ${className}`}
            style={style}
            disabled={disabled}
        />
    );
};

export default SearchInput;
